const mutations = {
  setTabData(state, { tabName, data }) {
    if (state.tabData[tabName]) {
      state.tabData[tabName] = { ...state.tabData[tabName], ...data };
    }
  },

  resetTabData(state, tabName) {
    if (state.tabData[tabName]) {
      const baseData = {
        pagination: {
          itemsPerPage: 10,
          itemsPerPageArray: [10, 20, 50, 100],
          page: 1,
        },
        totalItems: 0,
        searchBy: "customer_name",
        searchValue: "",
        status: {
          value: tabName === "active" ? "ACTIVE" : tabName.toUpperCase(),
        },
        showBy: { value: "created_at" },
        dateRange: null,
        type: { value: "ALL" },
        isSPKLinked: { value: "ALL" },
      };

      // Only add policy_status for active and maturity tabs
      if (tabName === "active" || tabName === "maturity") {
        baseData.policy_status = { value: "ALL" };
      }

      state.tabData[tabName] = baseData;
    }
  },
};

export default mutations;
